import { useT } from "../lang/LangContext";
import { SectionHeading } from "./SectionHeading";

export function About() {
  const t = useT();

  return (
    <section
      id="about"
      style={{ maxWidth: 1180, margin: "0 auto", padding: "64px 20px" }}
    >
      <SectionHeading index="01">{t("About", "Sobre")}</SectionHeading>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
          gap: 22,
        }}
      >
        <div
          style={{
            border: "3px solid var(--fg)",
            background: "var(--card)",
            padding: 24,
            boxShadow: "8px 8px 0 var(--fg)",
          }}
        >
          <p style={{ margin: "0 0 14px", fontSize: 16, lineHeight: 1.65 }}>
            {t(
              "I'm a senior software engineer from Uberlândia, Brazil. I build AI-powered internal platforms and full-stack products, the kind that quietly delete hours of manual work from somebody's week.",
              "Sou engenheiro de software sênior, de Uberlândia, Brasil. Construo plataformas internas com IA e produtos full-stack, daqueles que apagam silenciosamente horas de trabalho manual da semana de alguém."
            )}
          </p>
          <p style={{ margin: 0, fontSize: 16, lineHeight: 1.65 }}>
            {t(
              "Started as an intern writing SQL scripts. Now I own architecture, cloud infra, and production reliability. Same obsession, bigger blast radius.",
              "Comecei como estagiário escrevendo scripts SQL. Hoje sou responsável por arquitetura, infraestrutura em nuvem e confiabilidade em produção. A mesma obsessão, com um raio de impacto maior."
            )}
          </p>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 14,
            alignContent: "start",
          }}
        >
          <div
            style={{
              border: "3px solid var(--fg)",
              padding: 18,
              background: "var(--bg)",
            }}
          >
            <div
              style={{
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: 40,
                color: "var(--accent)",
                lineHeight: 1,
              }}
            >
              5+
            </div>
            <div style={{ fontSize: 12, letterSpacing: "0.14em", marginTop: 6 }}>
              {t("YEARS SHIPPING", "ANOS ENTREGANDO")}
            </div>
          </div>
          <div
            style={{
              border: "3px solid var(--bg)",
              padding: 18,
              background: "var(--fg)",
              color: "var(--bg)",
            }}
          >
            <div
              style={{
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: 40,
                lineHeight: 1,
              }}
            >
              1
            </div>
            <div style={{ fontSize: 12, letterSpacing: "0.14em", marginTop: 6 }}>
              {t("PRODUCT OF MY OWN", "PRODUTO PRÓPRIO")}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
